// extracted by mini-css-extract-plugin
export default {"showOnMediumScreensAndAbove":"showOnMediumScreensAndAbove-KCi9GyI7","hideOnMediumScreensAndAbove":"hideOnMediumScreensAndAbove-pGXXO72T"};